import React, { useEffect, useRef } from "react";
import { redJodi } from "../JodiCharts/Chart.config";

/* ---------- Skeleton Row Component ---------- */
const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, i) => (
      <td key={i} className="cc">
        <div className="tw-animate-pulse tw-h-8 tw-bg-gray-200 tw-rounded-md tw-m-1" />
      </td>
    ))}
  </tr>
);

/* ---------- Reusable ShreeDay Table ---------- */
const ShreeDayTable = ({ staticData, chartData }) => {
  const tableEndRef = useRef(null);
  const colCount = 7; // MON-SUN

  // Check if data is available
const isLoading = !chartData || chartData.length === 0;

  // Auto-scroll to bottom when chartData updates
  useEffect(() => {
    tableEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chartData]);

  const renderCell = (value) => {
    const isRed = redJodi.map((j) => parseInt(j)).includes(parseInt(value) || 0);
    return (
      <div className="kalyan-chart-number-black">
        <span className={`cp ${isRed ? "text-danger" : "text-dark"}`}>
          {value ?? "-"}
        </span>
      </div>
    );
  };

  return (
    <div className="tw-overflow-x-auto">
      <table className="table fw-bold tw-w-full" border="collapse">
        <thead>
           <tr className="tw-text-center">
            <th className="ch">MON</th>
            <th className="ch">TUE</th>
            <th className="ch">WED</th>
            <th className="ch">THU</th>
            <th className="ch">FRI</th>
            <th className="ch">SAT</th>
            <th className="ch">SUN</th>
          </tr>
        </thead>
        <tbody>
          {/* ---------- STATIC DATA OR SKELETON ---------- */}
          { staticData.map((group, groupIndex) => (
                <tr key={`static-${groupIndex}`}>
                  {group.map((item, idx) => (
                    <td key={idx}>{renderCell(item.value)}</td>
                  ))}
                </tr>
              ))}

          {/* ---------- DYNAMIC DATA OR SKELETON ---------- */}
          {isLoading
            ? Array.from({ length: 3 }).map((_, i) => (
                <SkeletonRow key={`dynamic-skel-${i}`} colCount={colCount} />
              ))
            : chartData.map((item1) => (
                <tr key={item1.id}>
                  {item1.data.map((nestedItem) => {
                    const combine = nestedItem.relatedData?.[0]?.winningDigit ?? "";
                    return <td key={nestedItem.id}>{renderCell(combine)}</td>;
                  })}
                </tr>
              ))}

          {/* Dummy row for scroll */}
          <tr ref={tableEndRef} />
        </tbody>
      </table>
    </div>
  );
};

export default ShreeDayTable;
